import { render, staticRenderFns } from "./rightBottom2.vue?vue&type=template&id=4c65aa0a"
import script from "./rightBottom2.vue?vue&type=script&lang=js"
export * from "./rightBottom2.vue?vue&type=script&lang=js"
import style0 from "./rightBottom2.vue?vue&type=style&index=0&id=4c65aa0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports